import { storageLocationIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const recordDirectBinPick = {
  name: "recordDirectBinPick" as const,
  input: z.object({
    fulfillmentGroupId: z.string(),
    binSelections: z.record(
      z.string(),
      z.array(
        z.object({
          storageLocationId: storageLocationIdFormat.schema,
          quantity: z.number(),
        }),
      ),
    ),
  }),
  output: z.object({ transferSessionId: z.string() }),
};
